import { render, staticRenderFns } from "./ParticipationTypeEditCard.vue?vue&type=template&id=40c7e8fe&scoped=true"
import script from "./ParticipationTypeEditCard.vue?vue&type=script&lang=js"
export * from "./ParticipationTypeEditCard.vue?vue&type=script&lang=js"
import style0 from "./ParticipationTypeEditCard.vue?vue&type=style&index=0&id=40c7e8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7e8fe",
  null
  
)

export default component.exports